<template>
<div>
  <div class="row vh-100">
    <template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i v-if="alert.type === 'success'" class="icon fa fa-check"></i>
          <i class="icon fa fa-ban" v-else></i>
          {{'alert_' + alert.type | translate}}!</h4>
        <li v-for="e in alert.message">
          {{e}}
        </li>
      </b-alert>
    </template>
    <div class="loading-container">
      <div class="overlay" v-show="loading">
        <div class="text-center">
          <img class="loading-gif" src="/static/img/blabla.svg" alt="loading-spinner"/>
          <h2>Anmeldung läuft...</h2>
          <span>Sie werden im Anschluss weitergeleitet. Bitte gedulden Sie sich einen Moment.</span>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Redirect',
  data() {
    return {
      loading: false,
      code: '',
      state: '',
      id_token: '',
      alerts: []
    }
  },
  methods: {
    checkCredentials () {
      let store = this.$store
      this.loading = true
      this.getUrlParams()
      window.localStorage.clear()
      API.post('okta/callback', { code: this.code, state: this.state })
        .then(response => {
          let data = response.data
          store.commit('updateUser', data)
          store.commit('updateRoles', data.roles)
          store.commit('updateToken', JSON.parse(JSON.stringify(data.token)))
          store.commit('updateLoggedInStatus', true)
          API.all([API.get(`orders/orderFilters`), API.get(`salesChannels`)])
            .then(API.spread((response, channels) => {
              store.commit('updateOrderStatusFilters', response.data.status)
              store.commit('updateOrderPaymentsFilters', response.data.payments)
              store.commit('updateOrderChannelsFilters', response.data.channels)
              store.commit('updateSalesChannels', channels.data)
              store.commit('updateOrderCountries', response.data.countries)
            }))
          this.$router.push('/home')
          this.loading = false
        })
        .catch(error => {
          let message = []
          let data = error.response.data
          Object.keys(data).forEach(x => {
            message.push(typeof data[x] === 'string' ? data[x] : data[x][0])
          })
          let alert = {type: 'danger', dismiss: 4, message: message}
          this.alerts.push(alert)
          this.loading = false
        })
    },
    getUrlParams () {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      this.code = urlParams.get('code')
      this.state = urlParams.get('state')
    },
  },
  mounted() {
    this.checkCredentials()
  }
}
</script>

<style>
  .loading-container {
    width: 400px;
    padding: 2rem 1rem 2rem 1rem;
    margin-right: auto;
    margin-left: auto;
  }
</style>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/Redirect.vue